import React, { Component } from "react";
import "./dropdown.style.scss";
export default class Dropdown extends Component {
  render() {
    return (
      <div className="form-group raroc-tag-group">
        <label className="raroc-tag-label">{this.props.title}</label>
        <div className="raroc-tags">
          {this.props.options.map(({ label, value }) => (
            <button
              key={value}
              type="button"
              className={
                "raroc-tag" + (this.props.value === value ? " active" : "")
              }
              onClick={() => this.props.onChange(value)}
            >
              {label}
            </button>
          ))}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/pages/Raroc/UploadFile/Dropdown.js